export const GEOLOCATION_CHANGED = 'GEOLOCATION_CHANGED'

export const GEOLOCATION_ERROR = 'GEOLOCATION_ERROR'

export const SET_CURRENT_SITE = 'SET_CURRENT_SITE'
